// Entry point for the build script in package.json

/**
 * This file is generated using  
 *   RAILS_ENV=production rails javascript:install:esbuild
 * through jsbunding-rails and nodejs.
 */

/**
 * jQuery
 * » 1. Import jQuery
 * » 2. Export it to the global window object
 */
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

/**
 * We use SVG + JavaScript instead of Web Fonts + CSS
 * Resource: https://docs.fontawesome.com/web/dig-deeper/webfont-vs-svg
 */
import "@fortawesome/fontawesome-free/js/all.js";

/**
 * Illumio Support Application
 */
import { IllumioSupportTemplate } from "./common/support_template.js";
new IllumioSupportTemplate();
